<template>
  <div class="certificates-wizard">
    <!-- Engineer Profile Header -->
    <div class="engineer-profile">
      <div class="engineer-profile__inner">
        <div class="engineer-profile__left">
          <div class="engineer-profile__avatar">
            <img
              v-if="engineerStatusForm.photo"
              :src="engineerStatusForm.photo"
              alt="Engineer Photo"
              class="engineer-profile__avatar-img"
            >
            <div
              v-else
              class="engineer-profile__avatar-fallback"
            >
              <feather-icon
                icon="UserIcon"
                size="22"
              />
            </div>
          </div>

          <div class="engineer-profile__text">
            <div class="engineer-profile__name">
              {{ engineerStatusForm.name || '—' }}
            </div>
            <div class="engineer-profile__email">
              <feather-icon
                icon="MailIcon"
                size="14"
                class="mr-25"
              />
              <span>{{ engineerStatusForm.email || '—' }}</span>
            </div>
          </div>
        </div>
        <div class="engineer-profile__right">
          <b-button
            variant="outline-light"
            class="engineer-profile__back-btn"
            @click="goBack"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              size="16"
              class="mr-50"
            />
            Back
          </b-button>
          <b-button
            variant="light"
            class="engineer-profile__refresh-btn"
            :disabled="loader"
            @click="fetchDataCertificates"
          >
            <b-spinner
              v-if="loader"
              small
              type="grow"
              class="mr-50"
            />
            <feather-icon
              v-else
              icon="RefreshCwIcon"
              size="16"
              class="mr-50"
            />
            Refresh
          </b-button>
        </div>
      </div>
    </div>
    <!-- ── Wizard Step Navigator ─────────────────────── -->
    <div class="wizard-nav">
      <div
        v-for="(step, index) in steps"
        :key="step.key"
        class="wizard-nav__step"
        :class="{ 'wizard-nav__step--active': activeSection === step.key }"
        @click="activeSection = step.key"
      >
        <div
          class="wizard-nav__icon"
          :class="`wizard-nav__icon--${step.color}`"
        >
          <feather-icon
            :icon="step.icon"
            size="20"
          />
        </div>
        <div class="wizard-nav__label">
          <span class="wizard-nav__title">{{ step.title }}</span>
        </div>
        <div
          v-if="index < steps.length - 1"
          class="wizard-nav__connector"
        />
      </div>
    </div>

    <!-- ── Step Panels ────────────────────────────────── -->
    <transition
      name="panel-fade"
      mode="out-in"
    >

      <!-- Step 1 – Status Certificates -->
      <!-- <div
        v-if="activeSection === 'certificatesStatus'"
        key="certificatesStatus"
      >
        <CertificateCard
          title="Status Certificates"
          icon="AwardIcon"
          color="primary"
          :is-visible="isVisable.certificatesStatus"
          :loader="loader"
          @toggle-edit="toggleEdit('certificatesStatus')"
        >
          <CertificatesStatus
            :certificates-groups="certificatesGroups"
            :statuses-eng="statusesEng"
            :statuses-cer="statusesCer"
            :engineer-status-form="engineerStatusForm"
            :fetch-data-certificates="fetchDataCertificates"
          />
        </CertificateCard>
      </div> -->

      <!-- Step 2 – Permission Certificates -->
      <div
        v-if="activeSection === 'permissionCertificates'"
        key="permissionCertificates"
      >
        <CertificateCard
          title="Permission Certificates"
          icon="ShieldIcon"
          color="success"
          :is-visible="isVisable.permissionCertificates"
          :loader="loader"
          @toggle-edit="toggleEdit('permissionCertificates')"
        >
          <PermissionCertificates
            :engineer-status-form="engineerStatusForm"
            :options-status="optionsStatus"
            :options-allocation-sources="optionsAllocationSources"
            :fetch-data-certificates="fetchDataCertificates"
          />
        </CertificateCard>
      </div>

      <!-- Step 3 – Work Certificates -->
      <div
        v-else-if="activeSection === 'workCertificates'"
        key="workCertificates"
      >
        <CertificateCard
          title="Work Certificates"
          icon="BriefcaseIcon"
          color="info"
          :is-visible="isVisable.workCertificates"
          :loader="loader"
          @toggle-edit="toggleEdit('workCertificates')"
        >
          <WorkCertificates
            :all-data-cer-status="AllDataCerStatus"
            :engineer-form="engineerForm"
            :options-status-id="optionsStatusId"
            :all-certificates="allCertificates"
            :certificates-groups="certificatesGroups"
            :selected-certificate-groups="selectedCertificateGroups"
            :backend-work-sub-certificates="backendWorkSubCertificates"
            :statuses-cer="statusesCer"
            :statuses-eng="statusesEng"
            :fetch-data-certificates="fetchDataCertificates"
          />
        </CertificateCard>
      </div>

    </transition>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import axios from 'axios'
// import CertificatesStatus from './status-working-certificates/CertificatesStatus.vue'
import WorkCertificates from './status-working-certificates/WorkCertificates.vue'
import PermissionCertificates from './status-working-certificates/PermissionCertificates.vue'
import CertificateCard from './status-working-certificates/CertificateCard.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    CertificateCard,
    WorkCertificates,
    // CertificatesStatus,
    PermissionCertificates,
  },
  setup() {
    const engineerStatusForm = ref({
      name: '',
      email: '',
      photo: '',
      status_id: [],
    })
    const engineerForm = ref({
      name: '',
      email: '',
      certificates: [],
      subCertificates: {},
    })

    return {
      engineerStatusForm,
      engineerForm,
    }
  },
  data() {
    return {
      activeSection: 'permissionCertificates',
      steps: [
        // {
        //   key: 'certificatesStatus',
        //   title: 'Status Certificates',
        //   icon: 'AwardIcon',
        //   color: 'primary',
        // },
        {
          key: 'permissionCertificates',
          title: 'Permission Certificates',
          icon: 'ShieldIcon',
          color: 'success',
        },
        {
          key: 'workCertificates',
          title: 'Work Certificates',
          icon: 'BriefcaseIcon',
          color: 'info',
        },
      ],
      loader: false,
      isVisable: {
        certificatesStatus: false,
        workCertificates: false,
        permissionCertificates: false,
      },
      certificatesGroups: [],
      statusesEng: [],
      statusesCer: [],
      AllDataCerStatus: {},
      allCertificates: [],
      optionsStatus: [],
      optionsStatusId: [],
      optionsAllocationSources: [],
      /** Sub-cert IDs persisted on the server per group (`name.ar` key); used to show Certificate Status Entry only for backend-loaded rows */
      backendWorkSubCertificates: {},
    }
  },
  computed: {
    selectedCertificateGroups() {
      return this.engineerForm.certificates
        .map(cert => {
          const group = this.allCertificates.find(g => g.value === cert)
          if (group) {
            return {
              ...group,
              certificates: group.certificates.map(certif => ({
                value: certif.id,
                text: `${certif.name.ar} - ${certif.name.en}`,
                span: `${this.AllDataCerStatus[certif.id]?.join(' - ') ?? ''}`,
              })),
            }
          }
          return null
        })
        .filter(group => group !== null)
    },
  },
  mounted() {
    this.fetchDataCertificates()
  },
  methods: {
    goBack() {
      if (typeof window !== 'undefined' && window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'engineers' })
      }
    },
    toggleEdit(section) {
      Object.keys(this.isVisable).forEach(key => {
        this.isVisable[key] = key === section ? !this.isVisable[key] : false
      })
    },
    async fetchDataCertificates() {
      try {
        this.loader = true
        await Promise.all([this.getEngineerStatus(), this.getCertificatesGroups(), this.getStatusesGroups(), this.showEngineer(), this.getEngineer()])
      } finally {
        this.loader = false
      }
    },

    async getEngineerStatus() {
      const res = await axios.get('certificate')
      this.allCertificates = decryptData(res.data.payload).data.groups.map(item => ({
        value: item.name.ar,
        text: `${item.name.ar} - ${item.name.en}`,
        certificates: item.certificates,
      }))
      this.optionsStatusId = this.allCertificates.map(item => ({
        value: item.value,
        text: item.text,
      }))
    },
    async getCertificatesGroups() {
      const response = await axios.get(`engineer/${this.$route.params.id}`)
      if (response.status === 200) {
        const userData = decryptData(response.data.payload).data.engineer.certificates_groups
        this.certificatesGroups = userData.map(item => ({
          value: item.id,
          text: `${item.name.ar} - ${item.name.en}`,
          certificates: item.certificates,
        }))

        this.engineerForm.certificates = userData.map(item => item.name.ar)
        const backendWorkSubCerts = {}
        userData.forEach(item => {
          const subCerts = item.certificates.map(cert => cert.id)
          backendWorkSubCerts[item.name.ar] = [...subCerts]
          const statuses = item.certificates.map(cert => ({
            id: cert.id,
            statuses: cert.statuses.map(status => status.status.status),
          }))
          statuses.forEach(status => {
            this.AllDataCerStatus[status.id] = status.statuses
          })
          this.$set(this.engineerForm.subCertificates, item.name.ar, subCerts)
        })
        this.backendWorkSubCertificates = backendWorkSubCerts
      }
    },
    async getStatusesGroups() {
      const response = await axios.get('/certificate-status')
      if (response.status === 200) {
        const statusesData = decryptData(response.data.payload).data.status.map(item => ({
          value: item.id,
          text: item.status,
        }))
        this.statusesEng = statusesData.filter(status => [2, 10, 9, 5].includes(status.value))
        this.statusesCer = statusesData.filter(status => ![2, 10, 9, 5].includes(status.value))
        this.statuses = [...this.statusesEng, ...this.statusesCer]
      }
    },
    async showEngineer() {
      if (this.$route.params.id) {
        const response = await axios.get(`/register/site/user/${this.$route.params.id}`)

        if (response.status === 200) {
          const userData = decryptData(response.data.payload).data.user
          this.engineerStatusForm.name = userData?.name
          this.engineerStatusForm.email = userData?.email
          this.engineerStatusForm.photo = userData?.photo
          this.engineerStatusForm.status_id = userData.status.map(item => item.id)
          this.engineerStatusForm.allocation_sources = Array.isArray(userData.allocation_sources) ? userData.allocation_sources.map(item => item) : []
        }
      }
    },
    async getEngineer() {
      const res = await axios.get('engineer-status')

      const decryptedData = decryptData(res.data.payload)
      this.optionsStatus = decryptedData.data.status.map(item => ({
        value: item.id,
        text: item.status,
      }))

      this.optionsAllocationSources = [
        { value: 'saber', text: 'Saber' },
        { value: 'jeem1', text: 'Jeem 1' },
        { value: 'sfda', text: 'SFDA' },
        { value: 'sfda-eg', text: 'SFDA Egypt' },
        { value: 'moiat', text: 'Moiat' },
        { value: 'sls', text: 'SLS' },
        // { value: 'qfda', text: 'QFDA' },
        { value: 'goeic', text: 'GOEIC' },
        { value: 'moph', text: 'MOPH' },
        { value: 'halal-jordan', text: 'Halal Jordan' },
        { value: 'halal-egypt', text: 'Halal Egypt' },
        { value: 'halal-united arab emirates', text: 'Halal UAE' },
      ]
    },
  },
}
</script>

<style lang="scss">
@import './status-working-certificates/certificates-wizard.scss';

.engineer-profile {
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  border-radius: 16px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.25rem;
  box-shadow: 0 6px 26px rgba(115, 103, 240, 0.28);
  color: #fff;
}

.engineer-profile__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.engineer-profile__left {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 240px;
}

.engineer-profile__avatar {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  flex-shrink: 0;
}

.engineer-profile__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.engineer-profile__avatar-fallback {
  color: rgba(255, 255, 255, 0.95);
}

.engineer-profile__text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.engineer-profile__name {
  font-weight: 800;
  font-size: 1.1rem;
  letter-spacing: -0.01em;
  line-height: 1.2;
  word-break: break-word;
}

.engineer-profile__email {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.92);
  word-break: break-word;
}

.engineer-profile__right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.engineer-profile__back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-weight: 700;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 255, 255, 0.65) !important;
  color: #fff !important;
  background: rgba(255, 255, 255, 0.14) !important;
  padding: 0.5rem 1rem;
}

.engineer-profile__back-btn:hover {
  background: rgba(255, 255, 255, 0.24) !important;
  border-color: rgba(255, 255, 255, 0.85) !important;
  color: #fff !important;
}

.engineer-profile__refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-weight: 700;
  border-radius: 10px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  color: #7367f0 !important;
  border: none !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  padding: 0.5rem 1rem;
}

.engineer-profile__refresh-btn:hover {
  background: #fff !important;
  color: #5e50ee !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.14);
}
</style>
